/**
 * 全局配置注册
 * 包含全局函数、过滤器、指令的注册
 */

import Vue from 'vue';
import base from '@/utils/base.js';
import * as directives from '@/directive';
import * as filters from '@/filters';

// 全局函数和配置
export function initializeGlobals() {
    // 注册全局函数
    Vue.use(base);

    // 注册全局过滤器
    Object.keys(filters).forEach(key => {
        Vue.filter(key, filters[key]);
    });

    // 注册全局指令
    Object.keys(directives.default).forEach(key => {
        Vue.directive(key, directives.default[key]);
    });
}
